//list of restaurants
const restaurants = [
    {
        title: 'Hot Burger Opernyi Teatr',
        url: 'hotburgerteatr-lviv-ua',
        id: 1
    },
    {
        title: 'Hot Burger Varenichna',
        url: 'varenyky-lviv-ua',
        id: 2
    },
    {
        title: 'Hot Burger Cheburechna',
        url: 'chebureckh-lviv-ua',
        id: 3
    },
]

export default restaurants;